import { dataMediaAdd } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMediaAdd = /*#__PURE__*/createIcon(dataMediaAdd)
export default IconMediaAdd
